module.exports = __webpack_public_path__ + "img/2.67193382.jpg";